import script from "./EditorGifModule.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorGifModule.vue?vue&type=script&setup=true&lang=js"

import "./EditorGifModule.vue?vue&type=style&index=0&id=5c396a86&lang=scss"

const __exports__ = script;

export default __exports__